import store from "../store";

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}
export default {
  created() {
    const tenant = store.getters["tenant/tenantInfo"];
    const title = getTitle(this);
    if (title) {
      document.title = tenant.siteTitle + " - " + title;
    }
  }
};
